'use strict';

module.exports = require('dibs-token-replace');



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/tokenReplace.js
// module id = 2633
// module chunks = 64